export default function findingUniqueNameDirective(
  $q,
  $timeout,
  amSharedModelService
) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    $timeout(
      () => {
        const findingCategoryId = attributes.findingCategoryId || -1;
        const findingId = attributes.findingId || -1;

        const cache = {};
        ngModel.$asyncValidators.amFindingUniqueName = (modelValue) => {
          if (modelValue && cache[modelValue] !== true) {
            return amSharedModelService
              .checkFindingNameExists(findingCategoryId, findingId, modelValue)
              .then((nameExists) => {
                if (!nameExists) {
                  cache[modelValue] = true;
                  return $q.resolve();
                }
                cache[modelValue] = false;
                return $q.reject();
              })
              .catch(() => {
                cache[modelValue] = false;
                $q.reject();
              });
          }
          return $q.resolve();
        };
      },
      0
    );
  }
}

export const name = 'amFindingUniqueName';

findingUniqueNameDirective.$inject = [
  '$q',
  '$timeout',
  'amSharedModelService'
];
